import { createTheme } from '@mui/material/styles';

// SERB look: warm paper background, white panels, blue accent. Follows the device's light/dark setting.
export const theme = createTheme({
  // 'data': the colour mode is a data attribute on the page, so it can follow the device (default) or be chosen in Settings
  cssVariables: { colorSchemeSelector: 'data' },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: '#1a6fe8' },
        success: { main: '#12a150' },
        warning: { main: '#e8890c' },
        error: { main: '#e5484d' },
        info: { main: '#3b82f6' },
        background: { default: '#f4f6fb', paper: '#ffffff' },
        text: { primary: '#1b2438', secondary: '#667085' },
        divider: '#e6e9f0',
      },
    },
    dark: {
      palette: {
        primary: { main: '#5b9cf5' },
        success: { main: '#3ecf80' },
        warning: { main: '#f0a043' },
        error: { main: '#f2706f' },
        info: { main: '#6aa3f8' },
        background: { default: '#0f1420', paper: '#171e2e' },
        text: { primary: '#e8ecf4', secondary: '#9aa4b8' },
        divider: '#262f43',
      },
    },
  },
  // xl is a very wide monitor: only there does Home put the activity column beside the tables
  breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1700 } },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif',
    h4: { fontSize: 28, fontWeight: 750 },
    h6: { fontSize: 16, fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    // fingers need bigger targets than mouse pointers: at least 44px on touch screens
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { '@media (pointer: coarse)': { minHeight: 44 } } },
    },
    MuiIconButton: { styleOverrides: { root: { '@media (pointer: coarse)': { minWidth: 44, minHeight: 44 } } } },
    MuiCard: { defaultProps: { variant: 'outlined' } },
    MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
    MuiTableCell: {
      styleOverrides: {
        root: { padding: '8px 8px', fontSize: 13 },
        head: { color: 'var(--mui-palette-text-secondary)', fontWeight: 600, fontSize: 12 },
      },
    },
  },
});

/** The dark blue side menu keeps its colour in light and dark mode */
export const SIDEBAR = { width: 240, bg: '#0b1d44', text: '#c7d2ea', active: '#1a6fe8' };
